export default "__VITE_ASSET__D_i8iyyi__"